/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTeacherCalendarRequest
 */
export interface GetTeacherCalendarRequest {
    /**
     * 
     * @type {Date}
     * @memberof GetTeacherCalendarRequest
     */
    fromDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetTeacherCalendarRequest
     */
    toDate: Date;
}

/**
 * Check if a given object implements the GetTeacherCalendarRequest interface.
 */
export function instanceOfGetTeacherCalendarRequest(value: object): value is GetTeacherCalendarRequest {
    if (!('fromDate' in value) || value['fromDate'] === undefined) return false;
    if (!('toDate' in value) || value['toDate'] === undefined) return false;
    return true;
}

export function GetTeacherCalendarRequestFromJSON(json: any): GetTeacherCalendarRequest {
    return GetTeacherCalendarRequestFromJSONTyped(json, false);
}

export function GetTeacherCalendarRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTeacherCalendarRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'fromDate': (new Date(json['fromDate'])),
        'toDate': (new Date(json['toDate'])),
    };
}

export function GetTeacherCalendarRequestToJSON(json: any): GetTeacherCalendarRequest {
    return GetTeacherCalendarRequestToJSONTyped(json, false);
}

export function GetTeacherCalendarRequestToJSONTyped(value?: GetTeacherCalendarRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fromDate': value['fromDate'].toISOString().substring(0,10),
        'toDate': value['toDate'].toISOString().substring(0,10),
    };
}

